import { SalesInvoiceItemBase } from '../abstract/sales-invoice-item-base.model';
import { QuotationItem } from '../quotation/quotation-item.model';
import { SalesInvoiceItemAllocation } from './sales-invoice-item-allocation.model';
import { NestedField, OmitField } from 'src/app/@shared/decorators/api-field.decorator';

export class SalesInvoiceItem extends SalesInvoiceItemBase {

    static override CLASS_NAME: string = 'SalesInvoiceItem';

    constructor(data: any) {
        super(data);
        this._allocations = this._allocations || [];
    }

    private _allocations!: SalesInvoiceItemAllocation[];
    private _downpaymentGrossAmountUsage!: number;
    private _downpaymentGrossAmountUsageOrg!: number;
    private _downpaymentNetAmountUsage!: number;
    private _downpaymentNetAmountUsageOrg!: number;
    private _downpaymentPctUsage!: number;
    private _downpaymentTaxAmountUsage!: number;
    private _downpaymentTaxAmountUsageOrg!: number;
    private _quotationItem!: QuotationItem;
    private _quotationItemQuantity!: number;

    @NestedField()
    public get allocations(): SalesInvoiceItemAllocation[] {
        return this._allocations;
    }

    public set allocations(value: any) {
        this._setValue('_allocations', value, 'SalesInvoiceItemAllocation');
    }

    @OmitField()
    public get downpaymentGrossAmountUsage(): number {
        return this._downpaymentGrossAmountUsage;
    }

    public set downpaymentGrossAmountUsage(value: any) {
        this._setValue('_downpaymentGrossAmountUsage', value, 'float');
    }

    @OmitField()
    public get downpaymentGrossAmountUsageOrg(): number {
        return this._downpaymentGrossAmountUsageOrg;
    }

    public set downpaymentGrossAmountUsageOrg(value: any) {
        this._setValue('_downpaymentGrossAmountUsageOrg', value, 'float');
    }

    public get downpaymentNetAmountUsage(): number {
        return this._downpaymentNetAmountUsage;
    }

    public set downpaymentNetAmountUsage(value: any) {
        this._setValue('_downpaymentNetAmountUsage', value, 'float');
    }

    @OmitField()
    public get downpaymentNetAmountUsageOrg(): number {
        return this._downpaymentNetAmountUsageOrg;
    }

    public set downpaymentNetAmountUsageOrg(value: any) {
        this._setValue('_downpaymentNetAmountUsageOrg', value, 'float');
    }

    public get downpaymentPctUsage(): number {
        return this._downpaymentPctUsage;
    }

    public set downpaymentPctUsage(value: any) {
        this._setValue('_downpaymentPctUsage', value, 'float');
    }

    @OmitField()
    public get downpaymentTaxAmountUsage(): number {
        return this._downpaymentTaxAmountUsage;
    }

    public set downpaymentTaxAmountUsage(value: any) {
        this._setValue('_downpaymentTaxAmountUsage', value, 'float');
    }

    @OmitField()
    public get downpaymentTaxAmountUsageOrg(): number {
        return this._downpaymentTaxAmountUsageOrg;
    }

    public set downpaymentTaxAmountUsageOrg(value: any) {
        this._setValue('_downpaymentTaxAmountUsageOrg', value, 'float');
    }

    @OmitField()
    public get quotationItem(): QuotationItem {
        return this._quotationItem;
    }

    public set quotationItem(value: any) {
        this._setValue('_quotationItem', value, 'QuotationItem');
    }

    public get quotationItemQuantity(): number {
        return this._quotationItemQuantity;
    }

    public set quotationItemQuantity(value: any) {
        this._setValue('_quotationItemQuantity', value, 'float');
    }

}
